var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAnswers = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 13,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 0a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h9ZM6.284 4.727H3.341a.59.59 0 1 0 0 1.182h2.943a.59.59 0 1 0 0-1.182ZM7.66 2.364H3.341a.59.59 0 1 0 0 1.181h4.318a.59.59 0 1 0 0-1.181Z"
})));

export default SvgAnswers;